export default {
	'请仔细阅读以下条款':'Please read the following clauses carefully',
	'承建商与参展商一定要在布展期间在线上确认好需要我公司开具的发票内容':'Builders and exhibitors must confirm the contents of invoices that need to be issued by our company online during the exhibition period.',
	'我公司开出的发票统一为二联《增值税':'The invoices issued by our company are unified into two copies of "Value Added Tax ',
	'普通':'Ordinary ',
	'发票》如需开具三联《增值税':'Invoice". Triple if needed "VAT ',
	'专用':'Special ',
	'发票》请在线上事先准确无误的登记好开票资料后，我公司将于':'Invoice",Please register the invoice information online accurately and correctly in advance.，Our company will send express delivery ',
	'1-2个月':'in 1-2 months',
	'后开出快递给到贵公司':' to your company .',
	'各项费用合计':'If the total cost is ',
	'低于1000元以下':'less than 1000 RMB',
	'的，我公司只开具《普通发票》，不提供《增值税专用发票》':' our company only issues "General Invoice" instead of "Special Invoice for Value Added Tax"',
	'一个公司发票抬头只开具':'A company invoice payable only ',
	'一张':'one ',
	'发票，请在':'invoice, please submit the invoice application  ',
	'同一时段':'at the same time,',
	'提交发票申请，以便我司进行开票金额的合并。':'so that our company can consolidate the invoice amount.',
	'以下费用由我公司提供发票：':'The following fees are invoiced by our company：',
	'水、电、气费、管理费、审图费、展具租赁费、施工证、加班费':'water, electricity, gas, management fee, drawing examination fee, exhibition rental fee, construction certificate and overtime fee.',
	'，此费用在我公司开具发票':'This fee is invoiced by our company.',
	'认真核对开票名称、金额是否正确，如发现错误请及时与主场相关人员联系':'Check the name and amount of the invoice carefully. If you find any mistakes, please contact the stakeholders in time.',
	'开票内容：':'Invoice content：',
	'*会展服务*展览服务费':'*Exhibition Service*Exhibition Service Fee',
	'同意':'Agree',
	'取消':'cancel',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/clause/invoiceClause.js